import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { store, persistor } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { Wrapper } from './components/LanguageWrapper/LanguageWrapper';

export default function renderToDOM() {
  const root = document.getElementById('root');
  if (root !== null) {
    ReactDOM.render(
      <React.StrictMode>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <BrowserRouter>
              <Wrapper>
                <App />
              </Wrapper>
            </BrowserRouter>
          </PersistGate>
        </Provider>
      </React.StrictMode>,
      document.getElementById('root'),
    );
  }
}
renderToDOM();
